import { useEffect } from 'react';

import { useNavigation } from 'hooks/useNavigation';

type ToggleJourneyProps = {
  on?: boolean;
  off?: boolean;
};

export const ToggleJourney = ({ on, off }: ToggleJourneyProps) => {
  const { next, eventTypes } = useNavigation();

  useEffect(() => {
    off && next({ eventType: eventTypes.BLOCK_JOURNEY });
    on && next({ eventType: eventTypes.ALLOW_JOURNEY });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

